import { ApiError } from '@/lib/api'

const UNAVAILABLE = 'Attribution is temporarily unavailable. Try again in a moment.'

/** A failed read in words a person can act on; an unknown failure is an outage, never an empty table. */
export function attributionErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.status === 403) {
    return 'Your role cannot see attribution. Ask an Owner or Administrator for access.'
  }
  if (error instanceof ApiError && error.status === 422) {
    return 'Attribution covers at most 400 days at a time. Choose a shorter date range.'
  }
  if (error instanceof ApiError && error.status === 429) return 'Too many requests just now. Wait a minute and try again.'
  return UNAVAILABLE
}
